module.exports = __webpack_public_path__ + "static/media/logo_light.8e7976b9.svg";